import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";
import { api } from "../lib/api";
import { ComicReader } from "./ComicReader";

export const ComicsSection = ({ onGate }) => {
  const [comics, setComics] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/comics").then(({ data }) => setComics(data)).catch(() => {});
  }, []);

  return (
    <section id="comics" className="relative py-24 sm:py-32 bg-[#050806]" data-testid="comics-section">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-14"
        >
          <div>
            <p className="font-accent text-xl tracking-[0.3em] text-emerald-400">THE COLLECTION</p>
            <h2 className="font-display text-5xl sm:text-7xl text-white mt-1">COMICS & ISSUES</h2>
          </div>
          <p className="text-gray-400 max-w-sm">Tap any cover to open the full-screen reader and scroll through the issue.</p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {comics.map((c, i) => (
            <motion.button
              key={c.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 5) * 0.08 }}
              onClick={() => setActive(c)}
              className="group relative text-left rounded-lg overflow-hidden border border-white/10 hover:border-emerald-400 bg-white/5 transition-colors duration-300"
              data-testid={`comic-card-${c.id}`}
            >
              <div className="aspect-[2/3] overflow-hidden">
                <img
                  src={c.cover}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-90" />
              <div className="absolute top-2 left-2 bg-emerald-500 text-emerald-950 font-display text-sm px-2 py-0.5 rounded">#{c.issue}</div>
              <div className="absolute bottom-0 p-3">
                <p className="font-display text-lg text-white leading-tight">{c.title}</p>
                <p className="text-emerald-400 text-xs mt-0.5">{c.subtitle}</p>
              </div>
              <div className="absolute inset-0 grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="btn-skew bg-emerald-500 text-emerald-950 font-accent text-lg px-4 py-1.5 flex items-center gap-1.5" data-testid={`comic-read-cta-${c.id}`}>
                  <span className="flex items-center gap-1.5"><BookOpen size={15} /> Read Now</span>
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      {active && <ComicReader comic={active} onClose={() => setActive(null)} />}
    </section>
  );
};
